/**
 * @generated SignedSource<<94c348b3c967b318a5ab9a2df039f36e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContactCreateInput = {
  externalRef: string;
  accountId: string;
  email: string;
  salutation?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  preferredName?: string | null;
  dob?: any | null;
  gender?: string | null;
  mobilePhone?: string | null;
  workPhone?: string | null;
  homePhone?: string | null;
  addressLineOne?: string | null;
  addressLineTwo?: string | null;
  city?: string | null;
  state?: string | null;
  countryId?: string | null;
  zip?: string | null;
  status: string;
  type: string;
  businessName?: string | null;
  occupation?: string | null;
  source: string;
  meta?: any | null;
  workflowStatus?: any | null;
  photoUrls?: any | null;
  createdBy?: string | null;
  userId?: string | null;
  unmindUserId?: string | null;
  timezone?: string | null;
  locale?: string | null;
  contactAccountId?: string | null;
  sessionLimitOverride?: number | null;
};
export type contactCreateMutation$variables = {
  connections: ReadonlyArray<string>;
  input: ContactCreateInput;
};
export type contactCreateMutation$data = {
  readonly createContact: {
    readonly contact: {
      readonly " $fragmentSpreads": FragmentRefs<"contactsInlineFragment">;
    };
  };
};
export type contactCreateMutation = {
  variables: contactCreateMutation$variables;
  response: contactCreateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "source",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdBy",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unmindUserId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "SessionLimitPayload",
  "kind": "LinkedField",
  "name": "sessionLimits",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sessionLimitType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amountRemaining",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expiryDate",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasActiveEventRequest",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "contactCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ContactPayload",
        "kind": "LinkedField",
        "name": "createContact",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Contact",
            "kind": "LinkedField",
            "name": "contact",
            "plural": false,
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "contactsInlineFragment",
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContactTeamMember",
                    "kind": "LinkedField",
                    "name": "contactTeamMembers",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamMember",
                        "kind": "LinkedField",
                        "name": "teamMember",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserProfile",
                            "kind": "LinkedField",
                            "name": "memberUserProfile",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "contactSessionLimitsRemainingInlineFragment",
                    "selections": [
                      (v11/*: any*/)
                    ]
                  },
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "contactHasActiveEventRequestInlineFragment",
                    "selections": [
                      (v12/*: any*/)
                    ]
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "contactCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ContactPayload",
        "kind": "LinkedField",
        "name": "createContact",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Contact",
            "kind": "LinkedField",
            "name": "contact",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ContactTeamMember",
                "kind": "LinkedField",
                "name": "contactTeamMembers",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamMember",
                    "kind": "LinkedField",
                    "name": "teamMember",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserProfile",
                        "kind": "LinkedField",
                        "name": "memberUserProfile",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "contact",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "Edge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "deb9f378fb9d0846b5006e4b5e9a7880",
    "id": null,
    "metadata": {},
    "name": "contactCreateMutation",
    "operationKind": "mutation",
    "text": "mutation contactCreateMutation(\n  $input: ContactCreateInput!\n) {\n  createContact(input: $input) {\n    contact {\n      ...contactsInlineFragment\n      id\n    }\n  }\n}\n\nfragment contactHasActiveEventRequestInlineFragment on Contact {\n  hasActiveEventRequest\n}\n\nfragment contactSessionLimitsRemainingInlineFragment on Contact {\n  sessionLimits {\n    sessionLimitType\n    amountRemaining\n    expiryDate\n  }\n}\n\nfragment contactsInlineFragment on Contact {\n  id\n  firstName\n  lastName\n  source\n  email\n  accountId\n  createdAt\n  createdBy\n  contactTeamMembers {\n    id\n    teamMember {\n      id\n      memberUserProfile {\n        firstName\n        lastName\n        id\n      }\n    }\n  }\n  unmindUserId\n  ...contactSessionLimitsRemainingInlineFragment\n  ...contactHasActiveEventRequestInlineFragment\n}\n"
  }
};
})();

(node as any).hash = "bf05a82ef578a2e301c35a073a53efd6";

export default node;
